var $ca127cbe8e8da712$exports = {};
$ca127cbe8e8da712$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Odabir boje`,
    "colorSwatch": `uzorak boje`,
    "transparent": `transparentno`,
    "twoDimensionalSlider": `2D kliza\u{10D}`
};


export {$ca127cbe8e8da712$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
